/* Validation logic for the upload form
    - Title is required and must be less than 100 characters long
    - Date is required
    - Description is required
    - Manual file is required for other material types except video and audio and must be a PDF or Word document
    - Thumbnail is required for other material types except video and audio and must be a JPEG or PNG image
    - Url is required for video and audio and must be a valid URL
    - Material Type is required
    - Manual field should be hidden for video and audio material types
    - Thumbnail field should be hidden for video and audio material types
    - Url field should be hidden for other material types
*/

const formValidation = (form, isEdit, files, setErrors, materialTypes = []) => {
    let errors = {};
    let isValid = true;

    // Validate title
    if (!form.title) {
        isValid = false;
        errors.title = 'Constitution Title is required';
    } else if (form.title.length > 100) {
        isValid = false;
        errors.title = 'Constitution Title must be less than 100 characters long';
    }

    // Validate date
    if (!form.date) {
        isValid = false;
        errors.date = 'Date is required';
    }

    // Validate description
    if (!form.description) {
        isValid = false;
        errors.description = 'Description is required';
    }

    // Validate category
    if (!form.catalog_group_id) {
        isValid = false;
        errors.catalog_group_id = 'Category is required';
    }

    // Validate material type / subcategory
    if (!form.material_type_id) {
        isValid = false;
        errors.material_type_id = 'Subcategory is required';
    }

    // Get the selected material type
    const selectedMaterialType = materialTypes.find(type => type.id === Number(form.material_type_id));
    const isAudioOrVideo = selectedMaterialType?.name?.toLowerCase().includes('audio') || 
                          selectedMaterialType?.name?.toLowerCase().includes('video');

    // Validate manual file (required for non-audio/video types)
    if (!isAudioOrVideo) {
        if (!isEdit && !files.manual) {
            isValid = false;
            errors.manual = 'Manual file is required for this material type';
        } else if (files.manual) {
            // Validate file type for manual
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(files.manual.type)) {
                isValid = false;
                errors.manual = 'Manual must be a PDF or Word document';
            }

            // Validate file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (files.manual.size > maxSize) {
                isValid = false;
                errors.manual = 'Manual file size must be less than 10MB';
            }
        }
    }

    // Validate thumbnail file (required for non-audio/video types)
    if (!isAudioOrVideo) {
        if (!isEdit && !files.thumbnail) {
            isValid = false;
            errors.thumbnail = 'Thumbnail is required for this material type';
        } else if (files.thumbnail) {
            // Validate file type for thumbnail
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedImageTypes.includes(files.thumbnail.type)) {
                isValid = false;
                errors.thumbnail = 'Thumbnail must be a JPEG or PNG image';
            }

            // Validate file size (max 5MB)
            const maxImageSize = 5 * 1024 * 1024; // 5MB
            if (files.thumbnail.size > maxImageSize) {
                isValid = false;
                errors.thumbnail = 'Thumbnail file size must be less than 5MB';
            }
        }
    }

    // Validate URL (required for audio/video types)
    if (isAudioOrVideo) {
        if (!form.url) {
            isValid = false;
            errors.url = 'URL is required for audio/video material types';
        } else if (!isValidUrl(form.url)) {
            isValid = false;
            errors.url = 'Please enter a valid URL';
        }
    }

    setErrors(errors);
    return isValid;
};

// Helper function to validate URL
const isValidUrl = (string) => {
    try {
        new URL(string);
        return true;
    } catch (_) {
        return false;
    }
};

export default formValidation;